import { useCallback } from "react";

import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

import { TimeFrameType } from "../types";

import { buildMetrics } from "./util";

type Props = {
  serviceName: string;
  timeFrame?: TimeFrameType;
};

const fetchMetrics = (client, timeFrame, serviceName) =>
  client.getResourcesByService({
    timeFrame,
    service: serviceName
  });

const useGridPoller = ({ serviceName, timeFrame }: Props) => {
  const client = useObservabilityPipelineHttpClient();

  const requestFn = useCallback(
    timeFrame => fetchMetrics(client, timeFrame, serviceName),
    [client, serviceName]
  );

  const formatData = useCallback(data => buildMetrics(data?.data), []);

  return usePoller({
    requestFn,
    timeFrame,
    formatData
  });
};

export default useGridPoller;
